import { put, takeEvery, all, delay, select, call, takeLeading } from 'redux-saga/effects';
import { getUser, updateUserData } from 'api/neway';
import * as types from '../constants/pensiongoals';

// refreshes user data every 30 seconds if the user isn't verified
// we do this to actively detect that a user verified
// hopefully this creates a good experience for our users


function* saveGoals() {
    const goals = yield select(state => state.pensiongoals);
    const user = yield select(state => state.user);

    try {
        let updatedUser;
        const currentPensionAge = user?.data?.pension?.base.pensionAge;
        const goalsPensionAge = goals.pension.pensionAgeCalculated;

        // update pensionAge if changed in goals
        if(goalsPensionAge && goalsPensionAge !== currentPensionAge){
            updatedUser =  yield call(updateUserData, 'pension', { goals, base: { ...user?.data?.pension?.base, pensionAge:goalsPensionAge }, pensionAge:goalsPensionAge  });
            yield put({
                type: 'PENSION_ANALYSIS_CALCULATION_REQUEST',

            });
        } else {
            updatedUser = yield call(updateUserData, 'pension', { goals });
        }


        yield put({
            type: types.PENSIONGOALS_SAVE_SUCCESS,
            payload: { goals },
        });
        yield put({
            type: 'USER_UPDATED',
            payload: { user: updatedUser },
        });
    } catch (error) {
        yield put({ type: types.PENSIONGOALS_SAVE_FAILED, payload: error });
    }
}

export default function* userSaga() {
    yield all([takeEvery(types.PENSIONGOALS_SAVE_REQUEST, saveGoals)]);
}
